export default __webpack_public_path__ + "static/media/OAA.e9d14288.png";